
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planning-updates/[reference]",
      function () {
        return require("private-next-pages/planning-updates/[reference].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planning-updates/[reference]"])
      });
    }
  